import { Outlet, useOutletContext } from 'react-router-dom';
import { StoreProvider } from 'store';

import { MapApiProvider } from '../../components/Map/Map';
import { MapProvider } from '../../components/Map/context/Map.context';

export const StoreProviderLayout = () => {
  const context = useOutletContext();
  return (
    <MapApiProvider>
      <MapProvider id={'events'}>
        <StoreProvider>
          <Outlet context={context} />
        </StoreProvider>
      </MapProvider>
    </MapApiProvider>
  );
};
